import React from 'react';

import * as styles from './index.module.scss';

const PageLayout = ({ children }) => {
    return <div className={styles.page}>{children}</div>;
};

export default PageLayout;
